import { Grid, MenuItem, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { DynamicFormHandlerProps } from "..";

export default function DynRemoverTituloApGlobal({ spec, extras }: DynamicFormHandlerProps) {
    const { control, setValue } = useFormContext();
    const titulos = extras.titulos || [];

    return (
        <Grid container spacing={2} mt={1}>
            <Grid size={{xs:12}}>
                <Controller
                    name={`${spec.name}`}
                    control={control}
                    rules={{ required: "Campo obrigatório" }}
                    render={({ field, fieldState: { error, invalid } }) => {
                        const safeValue = Array.isArray(field.value)
                        ? field.value.map((obj) => JSON.stringify(obj))
                        : [];
                      

                        return (
                            <TextField
                                required
                                {...field}
                                value={safeValue}
                                select
                                label="Títulos"
                                fullWidth
                                error={invalid}
                                helperText={error?.message}
                                SelectProps={{
                                    multiple: true,
                                }}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (Array.isArray(value)) {
                                        const selectedObjects = value.map((s) => JSON.parse(s));
                                        field.onChange(selectedObjects);
                                        setValue(`${spec.name}`, selectedObjects);
                                    }
                                }}
                            >
                                {titulos?.map((tit: { titulo: string, titulo_label: string }) => (
                                    <MenuItem key={tit.titulo} value={JSON.stringify(tit)}>
                                        {tit.titulo_label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        );
                    }}
                />
            </Grid>
        </Grid>
    );
}